import {LoginResponsePayload, LoginType} from '../../../models/api';

export default {
  isPasswordSet: true,
  isMobilePhoneSet: true,
  loginType: LoginType.EskNumber,
} as LoginResponsePayload;
